import { FC, ChangeEvent } from "react";

import { ICompany } from "Bands/types";
import { Radio, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { MutedText } from "shared/styles";

interface IBillingInfoSelectProps {
  company: ICompany;
  disabled?: boolean;
  checked?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const BillingInfoSelect: FC<IBillingInfoSelectProps> = ({
  company: { id, name, billingAddress, vat },
  disabled,
  checked,
  onChange,
}) => {
  return (
    <Radio
      name="billing-info"
      size="lg"
      value={id}
      checked={checked}
      label={
        <Spacer size="s">
          <Title>{name}</Title>
          <Spacer size="xxs">
            <MutedText>
              {billingAddress.city}, {billingAddress.country}
            </MutedText>
            <MutedText>{vat}</MutedText>
          </Spacer>
        </Spacer>
      }
      onChange={onChange}
      disabled={disabled}
    />
  );
};
